<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des espaces</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="action" slot-scope="props">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i
              class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="editEspace(props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="addEspace" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter un espace
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  export default {
    name: "GestionEspace",
    data() {
      return {
        columns: ['nom', 'ordre', 'description', 'action'],
        data: [],
        options: {
          headings: {
            nom: 'Nom',
            ordre: 'Ordre',
            description: 'Description',
            action: 'Action'
          },
          sortable: ['nom'],
          filterable: ['nom'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Nom"
          },
          orderBy: {column: 'ordre', ascending: false}
        }
      }
    },
    mounted() {
      this.all()
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      all() {
        this.$axios
          .get("/administration/espaces")
          .then(response => {
            this.data = response.data.espaces
          })
          .catch(() => {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cet espace ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .post("/administration/espaces/delete/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "L'espace a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(function (error) {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: 'Un problème est survenu, merci de contacter un administrateur',
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })

      },
      addEspace() {
        this.$router.push({path: '/administration/espaces/add'})
      },
      editEspace(id) {
        this.$router.push({path: '/administration/espaces/edit/'+id})
      }
    }
  }
</script>
